import VehicleHero from 'assets/images/psp/PSPHero/vehicle-hero.webp';
import VehicleCard1 from 'assets/images/icons/psp/vehiclecard1.svg';
import VehicleCard2 from 'assets/images/icons/psp/vehiclecard2.svg';
import VehicleCard3 from 'assets/images/icons/psp/vehiclecard3.svg';
import VehicleCard4 from 'assets/images/icons/psp/vehiclecard4.svg';
import VehicleCard5 from 'assets/images/icons/psp/vehiclecard5.svg';
import VehicleCard6 from 'assets/images/icons/psp/vehiclecard6.svg';
import VehicleCard7 from 'assets/images/icons/psp/vehiclecard7.svg';
import VehicleCard8 from 'assets/images/icons/psp/vehiclecard8.svg';
import VehicleCard9 from 'assets/images/icons/psp/vehiclecard9.svg';
import VehicleIcon from 'assets/images/icons/psp/vehicle.svg';

import VehicleContent1 from 'assets/images/psp/FeaturedContentImages/vehicle1.webp';
import VehicleContent2 from 'assets/images/psp/FeaturedContentImages/vehicle5.webp';
import VehicleContent3 from 'assets/images/psp/FeaturedContentImages/vehicle2.webp';
import VehicleContent4 from 'assets/images/psp/FeaturedContentImages/vehicle3.webp';
import { storageCategories } from '../utils/getPSPLinks';
const reviews = [
	{
		title: 'The whole experience went quickly and…',
		stars: 5,
		text: 'The whole experience went quickly and smoothly. The SelfStorage agent was pleasant and efficient. The price was right. The outdoor car lot was well-lit and very secure. I am pleased with my decision to store our vehicle here.',
		link: 'https://www.trustpilot.com/users/5d0a1c654e2d91287ebc737a',
		customerName: 'Lisa Dahn',
		date: 'October 15, 2021',
	},
	{
		title: 'Top notch service',
		stars: 5,
		text: 'I was able to reserve and pay online for the parking space to store my car without having to go to their office. Their follow-up phone call and emails made it a very simple and easy-to-follow process.',
		link: 'https://www.trustpilot.com/reviews/5fb408465e693f0a8429d399',
		customerName: 'Bill',
		date: 'November 17, 2020',
	},
	{
		title: 'The person on the phone was very helpful',
		stars: 5,
		text: 'The person on the phone was very helpful in finding me the perfect spot for our new RV. Thank you!',
		link: 'https://www.trustpilot.com/reviews/68b349ddd59b4f659b2d5041',
		customerName: 'Don C',
		date: 'August 31, 2025',
	},
	{
		title: 'This service is convenient and easy to use',
		stars: 5,
		text: 'The site provided the info I needed to find boat storage in my area at a reasonable rate. I was then able to reserve a space immediately before actually talking with anyone. This service is convenient and easy to use.',
		link: 'https://www.trustpilot.com/reviews/616b6e80234f1b1fe55c3604',
		customerName: 'Steve K',
		date: 'October 17, 2021',
	},
];

const faqs = [
	{
		question: 'How much does vehicle storage cost per month?',
		answer: 'Cheap vehicle storage near me typically ranges from $51.47/month for motorcycles to $165.85/month for RVs, depending on your vehicle size and whether you choose covered or uncovered storage.',
	},
	{
		question:
			"What's the difference between a vehicle storage unit and regular parking?",
		answer: 'Vehicle self storage offers secure, gated facilities with surveillance and often paved surfaces, while regular parking lots lack security features and proper vehicle protection.',
	},
	{
		question: 'Do I need insurance for my vehicle in storage?',
		answer: 'Your auto insurance should cover your stored vehicle, but verify with your provider — some policies reduce coverage for vehicles in storage over 30 days.',
	},
	{
		question: 'Can I work on my vehicle in a storage unit?',
		answer: 'Most facilities prohibit major repairs due to fire codes and environmental regulations, but basic maintenance like battery charging or cleaning is usually fine — always check facility rules first.',
	},
	{
		question: 'Is climate controlled vehicle storage worth the extra cost?',
		answer: 'For classic cars, vintage motorcycles, or vehicles with leather interiors, climate controlled vehicle storage prevents humidity damage, but most everyday vehicles do fine in covered or outdoor storage.',
	},
	{
		question: 'What documents do I need to rent vehicle storage?',
		answer: "Bring your driver's license, vehicle registration, proof of insurance, and a payment method — most facilities require vehicles to be registered and insured.",
	},
	{
		question: 'How do I calculate vehicle storage costs per day?',
		answer: "Divide the monthly rate by 30 — for example, a $132.43/month unit costs about $4.41 per day, though most facilities don't offer daily rentals.",
	},
];

export const VehicleContent = {
	type: 'Vehicle',
	reviews: reviews,
	sections: [
		{
			title: 'Vehicle Storage',
			background: 'default',
			modules: [
				{
					type: 'hero',
					props: {
						content: {
							title: 'Find Affordable Vehicle Self Storage',
							description:
								"Between the kids' bikes cluttering the garage, seasonal lawn equipment, and your partner's tools taking up every spare inch, there's barely room for your daily driver—let alone that boat you use three times a summer or the classic car you're restoring. \n\n" +
								"Sound familiar? You're not looking to spend a fortune on vehicle storage costs per day, but you do want a safe, secure spot that won't break the family budget. Finding cheap vehicle storage near me doesn't mean settling for a sketchy parking lot. \n\n" +
								"We'll help you find affordable vehicle storage units that make sense for your situation and your wallet.",
							image: VehicleHero,
							CTAtext: 'Find Vehicle Self Storage',
						},
					},
				},
			],
		},
		{
			title: 'Card Strip 1',
			modules: [
				{
					type: 'cardStrip',
					props: {
						heading: 'Do You Need a Vehicle Storage Unit?',
						description:
							'Vehicle storage units are an affordable and practical solution to space problems families like yours encounter every day. From garage space wars to seasonal rotations, vehicle storage can solve more problems than you think. \n\n' +
							'Here are a few ways to know if vehicle self storage is right for you.',
						cardData: [
							{
								title: 'When Your Garage Has Become a Storage Unit',
								imageSrc: VehicleCard1,
								content:
									"If you can't remember the last time your car actually fit in the garage, it might be time to move that boat, motorcycle, or project car to a proper vehicle storage unit.",
							},
							{
								title: 'For Seasonal Vehicles',
								imageSrc: VehicleCard2,
								content:
									'No sense paying insurance and taking up driveway space for that convertible you only drive in summer or the RV that sits idle nine months a year.',
							},
							{
								title: 'During Life Transitions',
								imageSrc: VehicleCard3,
								content:
									'Moving, downsizing, or going through a divorce? Vehicle self storage gives you a flexible place to keep cars, boats, or motorcycles while you figure out your next steps.',
							},
							{
								title: 'To Avoid HOA Headaches',
								content:
									'Many neighborhoods have rules about parking RVs, boats, or commercial vehicles in driveways. A vehicle storage unit solves the problem without the violation notices.',
								imageSrc: VehicleCard4,
							},
							{
								title: 'For DIY Projects',
								content:
									'Restoring a classic car in your driveway invites neighborhood complaints. Climate controlled vehicle storage (when available) gives you a dedicated space to work on your timeline.',
								imageSrc: VehicleCard5,
							},
						],
					},
				},
			],
		},
		{
			title: 'Content Section 1',
			background: 'blueWithMap',
			modules: [
				{
					type: 'content',
					props: {
						title: 'Types of Vehicle Storage Units',
						contentType: 'row-type',
						theme: 'dark',
						content: [
							`Not all [vehicle storage](https://www.selfstorage.com/blog/how-to-store-a-car/) is created equal. Here's what you'll typically find when searching for "cheap vehicle storage near me": \n\n` +
								'### Outdoor Uncovered Parking \n\n ' +
								'Think of it as a really secure parking lot. Your vehicle sits in an open space protected by gates, fencing, and surveillance cameras. This is the most budget-friendly option and works great for boats, trailers, and vehicles that already handle outdoor exposure. \n\n' +
								'### Covered Parking \n\n ' +
								'These carport-style spaces give your vehicle a roof overhead to protect from sun, rain, and snow. A solid middle-ground option that offers weather protection without the premium price of fully enclosed storage. \n\n' +
								'### Indoor Vehicle Storage Units \n\n ' +
								'Full four-wall protection with a roll-up door, just like a garage. Best for classic cars, vehicles with sensitive finishes, or anything you want completely protected from the elements. Some facilities offer climate controlled vehicle storage in enclosed units for extra protection.',
						],
					},
				},
			],
		},
		{
			title: 'Size Comparison Data',
			background: 'lighterBlue',
			modules: [
				{
					type: 'sizeComparisonSection',
					props: {
						content: {
							title: 'Vehicle Storage Unit Sizes & Pricing',
							image: VehicleIcon,
							contentdec:
								'*Pricing based on average rates across **SelfStorage.com** partner facilities*\n\n' +
								"**Quick Tip:** When calculating vehicle storage costs per day, remember that most facilities charge monthly. For a 10×20 unit at $132.43/month, that's roughly $4.41 per day - less than a coffee from your favorite local shop.",
						},
						storageData: [
							{
								size: '5×10',
								desc: [
									'**Average monthly cost:** $51.47',
									'**What fits:** Motorcycle, jet ski, small equipment',
									'**Best for:** Single bikes, watercraft, lawn equipment',
								],
							},
							{
								size: '10×10',
								desc: [
									'**Average monthly cost:** $82.81',
									'**What fits:** Motorcycle, ATV, compact car',
									'**Best for:** Bikes with room to walk around',
								],
							},
							{
								size: '10×15',
								desc: [
									'**Average monthly cost:** $109.48',
									'**What fits:** Sedan, small boat with trailer',
									'**Best for:** Most cars, small boats',
								],
							},
							{
								size: '10×20',
								desc: [
									'**Average monthly cost:** $132.43',
									'**What fits:** SUV, truck, medium boat',
									'**Best for:** Larger vehicles, work trucks',
								],
							},
							{
								size: '10×30',
								desc: [
									'**Average monthly cost:** $165.85',
									'**What fits:** RV, large boat, multiple motorcycles',
									'**Best for:** Campers, cabin cruisers',
								],
							},
						],
					},
				},
			],
		},
		{
			title: 'Content Section 2',
			noPaddingBottom: true,
			noPaddingTop: true,
			modules: [
				{
					type: 'content',
					props: {
						title: 'How to Choose the Right Vehicle Storage Unit Size',
						contentType: 'row-type',
						theme: 'light',
						content: [
							"Measure your vehicle from bumper to bumper, then add at least 2-3 feet of clearance on all sides. You want room to open doors, walk around, and access storage if you're keeping extra items inside.\n\n" +
								'**Size Guidelines:** \n\n' +
								'- **Motorcycle**: 5×10 gives you plenty of room \n\n' +
								'- **Sedan/Compact Car**: 10×15 is comfortable \n\n' +
								'- **SUV/Truck**: 10×20 allows door clearance \n\n' +
								'- **Small Boat (under 20 ft)**: 10×20 to 10×25 \n\n' +
								'- **RV/Large Boat**: 10×30 or larger (measure first!) \n\n' +
								"**Remember**: Going one size up costs maybe $20-30 more per month, but makes your life so much easier when you're loading and unloading.",
						],
					},
				},
			],
		},
		{
			title: 'Content Section 3',
			background: 'blueWithMap',
			modules: [
				{
					type: 'content',
					props: {
						title: 'Getting Your Vehicle Ready for Storage',
						contentType: 'row-type',
						theme: 'dark',
						content: [
							"You don't need to be a mechanic, but a few simple DIY steps will keep your vehicle in great shape:\n\n " +
								'**1. Top off the gas tank:**\n\n Prevents condensation and rust in the fuel system\n\n' +
								'**2. Change the oil:**\n\n Old oil has acids that can corrode your engine\n\n' +
								'**3. Clean it thoroughly:**\n\n Food crumbs and spills attract pests—not kidding\n\n' +
								'**4. Check tire pressure:**\n\n Keeps tires from developing flat spots\n\n' +
								'**5. Disconnect the battery:**\n\n Prevents slow drain and extends battery life\n\n' +
								'**6. Cover it up:**\n\n Basic car cover protects from dust and moisture\n\n',
						],
					},
				},
			],
		},
		{
			title: 'Card Strip 2',
			modules: [
				{
					type: 'cardStrip',
					props: {
						heading: 'What to Look for in Vehicle Self Storage',
						cardData: [
							{
								title: 'Paved and Level Surfaces',
								content:
									'Muddy or uneven ground is bad for tires and makes seasonal storage a headache. Stick with facilities that have paved parking areas.',
								imageSrc: VehicleCard6,
							},
							{
								title: 'Wide Driveways',
								content:
									"You need room to maneuver, especially if you're towing a boat or parking an RV. Check that the facility can actually accommodate your vehicle size.",
								imageSrc: VehicleCard7,
							},
							{
								title: 'Good Security',
								content:
									"Look for gated access, surveillance cameras, and good lighting. Your vehicle is a significant investment—make sure it's protected.",
								imageSrc: VehicleCard8,
							},
							{
								title: 'Convenient Access Hours',
								content:
									'If you use your boat or RV regularly during the summer, 24-hour access means grabbing it at 5 AM for that fishing trip without hassle.',
								imageSrc: VehicleCard9,
							},
							{
								title: 'Clear Policies',
								content:
									"Make sure you understand what maintenance you can do on-site (most facilities don't allow major repairs) and what documentation you'll need.",
								imageSrc: VehicleCard4,
							},
						],
					},
				},
			],
		},
		{
			title: 'Reviews Section',
			background: 'lighterBlue',
			modules: [
				{
					type: 'reviews',
					props: {
						reviewsData: {
							headerTitle: 'Vehicle Self Storage: ',
							reviews,
						},
					},
				},
			],
		},
		{
			title: 'FAQ Section',
			modules: [
				{
					type: 'faqs',
					props: {
						content: {
							faqs,
							header: 'Vehicle Self Storage FAQs',
						},
					},
				},
			],
		},
		{
			title: 'Featured Content ',
			background: 'darkBlue',
			modules: [
				{
					type: 'featuredContent',
					props: {
						data: {
							heading: 'Learn All About Vehicle Self Storage',
							type: 'unitCards',
							data: {
								slug: 'storage-size-guide-unit-cards',
								unitCards: [
									{
										title: 'Vehicle Storage',
										date: 'March 3, 2025',
										image: VehicleContent1,
										content:
											'Choosing the Right Storage Unit for Your Vehicle',
										url: 'https://www.selfstorage.com/blog/car-storage-size-guide/',
									},
									{
										title: 'Vehicle Storage',
										date: 'November 4, 2025',
										image: VehicleContent2,
										content:
											'Quick Guide to Proper Motorcycle Winter Storage',
										url: 'https://www.selfstorage.com/blog/guide-to-motorcycle-winter-storage/',
									},
									{
										title: 'Vehicle Storage',
										date: 'January 21, 2025',
										image: VehicleContent3,
										content:
											'RV & Camper Winterization: Essential Steps To Preparing Your RV For Winter',
										url: 'https://www.selfstorage.com/blog/rv-winterization-guide/',
									},
									{
										title: 'Vehicle Storage',
										date: 'September 9, 2025',
										image: VehicleContent4,
										content:
											'RV Storage: Long-Term Storage Types & Tips to Prepare',
										url: 'https://www.selfstorage.com/blog/long-term-rv-storage-tips-2/',
									},
								],
							},
						},
					},
				},
			],
		},
		{
			title: 'Link to other PSPs',
			background: 'lighterBlue',
			modules: [
				{
					type: 'links',
					props: {
						heading: {
							headingName: 'More ways to store',
						},
						type: 'unitCards',
						id: 'storage size unit cards',
						linksList: storageCategories.vehicle,
					},
				},
			],
		},
		{
			title: 'Storage Near You',
			background: 'gray',
			modules: [
				{
					type: 'storageNearYou',
					props: {
						type: 'Vehicle',
					},
				},
			],
		},
	],
};
